module.exports = __webpack_public_path__ + "img/login-bg.d8d54fde.png";